import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Forgot} from '../pages/auth/Forgot'
import Login from '../pages/auth/Login'
import ResetPassword from '../pages/auth/ResetPassword'
import { ResetPasswordSuccess } from '../pages/auth/ResetPasswordSuccess'
import { EmailSend } from '../pages/auth/EmailSend'

export default function AuthRouter () {
    return (
        <Routes>
            <Route path="/" element={<Login />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/forgotpassword" element={<Forgot />}/>
            <Route path="/emailsend/:email" element={<EmailSend />}/>
            <Route path="/resetpassword/:id/:tokenresetpassword" element={<ResetPassword />}/>
            <Route path="/cambiar-contrasena/:id/:tokenresetpassword" element={<ResetPassword />}/>
            <Route path="/resetpasswordsuccess" element={<ResetPasswordSuccess />}/>
            <Route path="*" element={<NotFoundPage />}/>
        </Routes>
    )
}